"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var models_1 = require("./models");
var engine_1 = require("./engine");
exports.calculateComparisonForGranularity = function (table, currentValue, comparison) {
    var comparedPoint;
    // index of the current value
    var idx = table.findIndex(function (value) { return value.timestamp.valueOf() === currentValue.timestamp.valueOf() && value.measure === currentValue.measure; });
    if (idx <= 0) {
        return undefined;
    }
    // comparing previous period
    if (!comparison || comparison.dateTrunc === models_1.DateTrunc.UNKNOWN) {
        comparedPoint = exports.calcuateComparisonByPoints(idx, 1, table);
    }
    else {
        // else we need to check for data for the date desired
        comparedPoint = exports.findComparisonValue(comparison, currentValue, table, idx);
        if (!comparedPoint) {
            // no value at the desired date; show no comparison
            return undefined;
        }
    }
    var previous = comparedPoint.measure;
    var absolute = currentValue.measure - previous;
    var percentage = absolute === 0 ? 0 : (absolute / previous);
    return {
        absolute: absolute,
        percentage: percentage,
        comparedPoint: comparedPoint,
    };
};
exports.generateComparisonLineByRange = function (table, windowedTable, comparison) {
    var currentRange = engine_1.getDateRange(windowedTable);
    if (!currentRange || !comparison) {
        return null;
    }
    else {
        var unit = exports.momentStringFromDateTrunc(comparison.compareTo);
        if (!unit) {
            return comparisonLineForPriorMark(table, windowedTable);
        }
        else {
            var amount = comparison.numberOfPeriods || 1;
            return comparisonLineForDateRange(currentRange, amount, unit, table);
        }
    }
};
var comparisonLineForPriorMark = function (table, windowedTable) {
    var windowLastPoint = engine_1.getInitialValue(windowedTable);
    if (!windowLastPoint) {
        return null;
    }
    var windowFirstPoint = windowedTable[0];
    var comparisonLastIndex = table.findIndex(function (value) { return value.timestamp.valueOf() === windowLastPoint.timestamp.valueOf() && value.measure === windowLastPoint.measure; }) - 1;
    var comparisonFirstIndex = table.findIndex(function (value) { return value.timestamp.valueOf() === windowFirstPoint.timestamp.valueOf() && value.measure === windowFirstPoint.measure; }) - 1;
    var comparisonPoints = comparisonPointsForPriorMark(table, comparisonFirstIndex, comparisonLastIndex);
    var comparisonLegendRange = engine_1.getComparisonDateRange(comparisonPoints);
    return {
        comparisonPoints: comparisonPoints,
        comparisonLegendRange: comparisonLegendRange
    };
};
var comparisonPointsForPriorMark = function (table, comparisonFirstIndex, comparisonLastIndex) {
    var comparisonPoints = [];
    table.forEach(function (point, index) {
        if (index >= comparisonFirstIndex && index <= comparisonLastIndex) {
            var timestamp = table[index + 1].timestamp;
            comparisonPoints.push({
                measure: point.measure,
                comparisonTimestamp: point.timestamp,
                timestamp: timestamp
            });
        }
    });
    return comparisonPoints;
};
var comparisonLineForDateRange = function (currentRange, amount, unit, table) {
    var firstComparison = engine_1.dateBefore(currentRange.first, amount, unit);
    var lastComparison = engine_1.dateBefore(currentRange.last, amount, unit);
    var comparisonRange = { first: firstComparison, last: lastComparison };
    var comparisonPoints = [];
    table.forEach(function (point) {
        if (engine_1.withinRange(comparisonRange, point.timestamp)) {
            var timestamp = engine_1.dateAfter(point.timestamp, amount, unit);
            comparisonPoints.push({
                measure: point.measure,
                comparisonTimestamp: point.timestamp,
                timestamp: timestamp
            });
        }
    });
    var comparisonLegendRange = engine_1.getComparisonDateRange(comparisonPoints);
    return {
        comparisonPoints: comparisonPoints,
        comparisonLegendRange: comparisonLegendRange
    };
};
exports.momentStringFromDateTrunc = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return 'seconds';
        }
        case models_1.DateTrunc.MINUTE: {
            return 'minutes';
        }
        case models_1.DateTrunc.HOUR: {
            return 'hours';
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return 'days';
        }
        case models_1.DateTrunc.MONTH: {
            return 'months';
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return 'weeks';
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return 'quarters';
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return 'years';
        }
        default: {
            // compare to previous point
            return undefined;
        }
    }
};
exports.findTargetDate = function (amount, unit, currentDate, table) {
    currentDate.subtract(amount, unit);
    var comparisonIndex = table.findIndex(function (value) { return currentDate.isSame(value.timestamp); });
    if (comparisonIndex < 0) {
        return undefined;
    }
    return table[comparisonIndex];
};
exports.calcuateComparisonByPoints = function (currentIndex, amount, table) {
    return table[currentIndex - amount];
};
exports.findComparisonValue = function (comparison, currentValue, table, currentIndex) {
    var currentDate = moment.utc(currentValue.timestamp);
    var amount = comparison.numberOfPeriods || 1;
    var unit = exports.momentStringFromDateTrunc(comparison.compareTo);
    if (!unit) {
        return exports.calcuateComparisonByPoints(currentIndex, amount, table); // just want 1 point away
    }
    return exports.findTargetDate(amount, unit, currentDate, table);
};
exports.calculateDataPointsWithComparison = function (data, comparison) {
    if (!comparison) {
        return data;
    }
    // The current index in the comparison array.
    // Since the data is sorted, we can walk the array down to keep up with 'data'.
    var comparisonIndex = 0;
    return data.map(function (dp) {
        while (comparisonIndex < comparison.length && comparison[comparisonIndex].timestamp < dp.timestamp) {
            comparisonIndex++;
        }
        var comparisonValue;
        if (comparisonIndex < comparison.length &&
            comparison[comparisonIndex].timestamp.getTime() === dp.timestamp.getTime()) {
            comparisonValue = comparison[comparisonIndex].measure;
        }
        return {
            measure: dp.measure,
            timestamp: dp.timestamp,
            comparison: comparisonValue,
        };
    });
};
//# sourceMappingURL=comparisonEngine.js.map